"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var margin_1 = __importDefault(require("src/utilities/styled/margin"));
var alignSelf_1 = __importDefault(require("src/utilities/styled/alignSelf"));
var fillColor_1 = __importDefault(require("./utilities/fillColor"));
var Icon = styled_components_1.default.svg.withConfig({
    shouldForwardProp: function (prop) { return prop !== 'color'; },
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  flex: 0 0 auto;\n  ", "\n  ", "\n  ", "\n"], ["\n  display: inline-block;\n  flex: 0 0 auto;\n  ", "\n  ", "\n  ", "\n"])), margin_1.default, alignSelf_1.default, fillColor_1.default);
exports.default = Icon;
var templateObject_1;
